import { GzProxyConfigurationWebComponent } from './component/GzProxyConfigurationWebComponent';

export { GzProxyConfigurationWebComponent };
